export default __webpack_public_path__ + "static/media/signal71Desktop.cd6b7043.jpg";